import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { spacing, colors, fonts, fontSize, radius, sizes } = redesignTheme;

export const useHelpModalFormStyles = makeStyles((theme: Theme) => ({
  helpContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
  helpHeaderBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  helpHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.sm,
  },
  helpTitle: {
    flex: 1,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.xl,
    lineHeight: '28px',
    color: colors.primary,
    margin: 0,
  },
  helpCloseButton: {
    padding: 0,
    color: colors.textBody,
    '& svg': {
      fontSize: 24,
    },
  },
  helpDescription: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: 'normal',
    color: colors.textBody,
    margin: 0,
  },
  helpLabelDark: {
    color: '#2d3648',
    letterSpacing: '-0.14px',
  },
  helpLabelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: spacing.xs,
    lineHeight: '16px',
  },
  helpOptional: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: '#838183',
    letterSpacing: '-0.12px',
    whiteSpace: 'nowrap',
  },
  helpSelectWrapper: {
    position: 'relative',
    width: '100%',
  },
  helpSelect: {
    width: '100%',
    height: sizes.inputHeight,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    padding: '0 36px 0 12px',
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    outline: 'none',
    appearance: 'none',
    boxSizing: 'border-box' as const,
    '&:focus': {
      borderColor: colors.primary,
    },
  },
  helpSelectIcon: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 16,
    color: colors.text,
    pointerEvents: 'none',
  },
  helpTextarea: {
    width: '100%',
    minHeight: 120,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    padding: spacing.xs,
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: '#2d3648',
    letterSpacing: '-0.16px',
    outline: 'none',
    resize: 'vertical' as const,
    boxSizing: 'border-box' as const,
    '&::placeholder': {
      color: colors.placeholder,
    },
    '&:focus': {
      borderColor: colors.primary,
    },
  },
  helpDropZone: {
    border: `1px dashed ${colors.border}`,
    borderRadius: 4,
    height: 160,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    cursor: 'pointer',
    padding: spacing.xs,
    boxSizing: 'border-box' as const,
    transition: 'border-color 0.2s ease, background-color 0.2s ease',
    '&:hover': {
      borderColor: colors.primary,
    },
  },
  helpDropZoneActive: {
    borderColor: colors.primary,
    backgroundColor: colors.hoverSurface,
  },
  helpDropZoneError: {
    borderColor: colors.error,
  },
  helpUploadIconWrapper: {
    width: 40,
    height: 40,
    borderRadius: radius.md,
    backgroundColor: '#eae9ea',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  helpUploadIcon: {
    fontSize: 24,
    color: colors.text,
  },
  helpUploadText: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    lineHeight: '24px',
    color: colors.text,
    textAlign: 'center',
  },
  helpUploadFormats: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    lineHeight: '16px',
    color: '#838183',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
      maxWidth: '100%',
    },
  },
  helpFileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    padding: '0 12px',
  },
  helpFileName: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primary,
  },
  helpErrorText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.error,
    margin: 0,
  },
}));
